"use client";

import React from "react";
import Link from "next/link";

import { NewButton } from "@/components/ui/NewButton";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";

export function HomeCtaButtons({ registerUrl }: { registerUrl: string }) {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <Link href="/book-a-demo" target="_self" data-mixpanel-id="other-book-a-demo">
        <NewButton variant="accent" size="lg" asChild className="text-base md:text-lg w-auto">
          Book Demo
        </NewButton>
      </Link>
    );
  }

  return (
    <>
      <a
        href={registerUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-mixpanel-id="other-start-free-trial"
      >
        <NewButton variant="accent" size="lg" arrow="grow" asChild className="text-base md:text-lg w-auto">
          Start Free Trial
        </NewButton>
      </a>
      <Link href="/book-a-demo" target="_self" data-mixpanel-id="other-book-a-demo">
        <NewButton variant="outlineAccent" size="lg" asChild className="text-base md:text-lg w-auto">
          Book Demo
        </NewButton>
      </Link>
    </>
  );
}

